export default {
  FILTER_STUDENT_COMPETENCIES_LIST: 'FilterStudentCompetenciesList',
  SORT_STUDENT_COMPETENCIES_LIST: 'SortStudentCompetenciesList',
  LOAD_STUDENT_COMPETENCIES_LIST_START: 'LoadStudentCompetenciesListStart',
  LOAD_STUDENT_COMPETENCIES_LIST_END: 'LoadStudentCompetenciesListEnd',
  LOAD_STUDENT_COMPETENCIES_LIST_DETAILS: 'LoadStudentCompetenciesListDetails',
  CHANGE_STUDENT_COMPETENCIES_LIST_EXPAND_STATE: 'ChangeStudentCompetenciesListExpandState'
};